import { useCurrentUser } from '@hotjar/user';
import { useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useStickyNotification } from '@hotjar/navigation';
import { Link } from '@hotjar/hotsauce';

const DEMO_INSTANCE_NAME = 'demo-mode';

/**
 * Hook that shows a top banner for demo mode.
 */
export const useDemoNotification = (): void => {
  const { t } = useTranslation();
  const { data: currentUser } = useCurrentUser();
  const { show, hide } = useStickyNotification();
  const [showDemoNotification, setShowDemoNotification] = useState(
    currentUser?.isDemoUser ?? false,
  );

  useEffect(() => {
    setShowDemoNotification(currentUser?.isDemoUser ?? false);
  }, [currentUser?.isDemoUser]);

  useEffect(() => {
    if (showDemoNotification) {
      show(DEMO_INSTANCE_NAME, {
        kind: 'warning',
        actionProps: { isExternal: true },
        text: (
          <>
            {t('sitebar.top-bar-message.demo-account-notification-message')}{' '}
            <Trans i18nKey="common:sitebar.top-bar-message.demo-account-notification-signup">
              <Link href="/register?logout=true" kind="inline" id="demoToSignUpLink">
                Sign up for free
              </Link>
              <Link href="/logout" kind="inline" id="demoToLoginLink">
                login here
              </Link>
            </Trans>
          </>
        ),
      });
    } else {
      hide(DEMO_INSTANCE_NAME);
    }
  }, [hide, show, showDemoNotification, t]);
};
